module.exports = __webpack_public_path__ + "static/media/voice-mail.7b12c422.svg";